export const SET_MAP_SELECTED = 'SET_MAP_SELECTED';
export const SET_IS_LOADING_MAPS = 'SET_IS_LOADING_MAPS';
export const SET_IS_LOADING_CREATE_MAP = 'SET_IS_LOADING_CREATE_MAP';
export const SET_IS_LOADING_UPDATE_MAP = 'SET_IS_LOADING_UPDATE_MAP';
export const SET_IS_LOADING_ADD_MAP_TO_CONNECTION = 'SET_IS_LOADING_ADD_MAP_TO_CONNECTION';
export const SET_IS_LOADING_DELETE_MAP_FROM_CONNECTION = 'SET_IS_LOADING_DELETE_MAP_FROM_CONNECTION';
export const DELETE_MAP = 'DELETE_MAP';
export const SET_IS_LOADING_DELETE_MAP = 'SET_IS_LOADING_DELETE_MAP';
export const ADD_FIELDS_TO_MAP = 'ADD_FIELDS_TO_MAP';
export const GET_MAPS = 'GET_MAPS';
export const CREATE_MAP = 'CREATE_MAP';
export const UPDATE_MAP = 'UPDATE_MAP';